/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MedicosControllerEliminarMedico$Params {

/**
 * UUID del médico a eliminar
 */
  uuidMedico: string;
}

export function medicosControllerEliminarMedico(http: HttpClient, rootUrl: string, params: MedicosControllerEliminarMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, medicosControllerEliminarMedico.PATH, 'delete');
  if (params) {
    rb.path('uuidMedico', params.uuidMedico, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

medicosControllerEliminarMedico.PATH = '/api/medicos/eliminar-medico/{uuidMedico}';
